import { Auth } from 'aws-amplify';
import axios from 'axios';
import APIS from '../apiUrl';

export const addFirmware = async (file: { name: string }, formData: any) => {
  // Split the filename to get the name and type
  const fileParts = file.name.split('.');
  const myFileName = fileParts[0];
  const myFileType = fileParts[1];
  return await Auth.currentSession().then(async session =>
    axios({
      method: 'POST',
      url: `${APIS.SENTINEL_API}/api/firmware/getsigned`,
      headers: {
        Authorization: `Bearer ${session.getAccessToken().getJwtToken()}`,
      },
      data: {
        fileName: myFileName,
        fileType: myFileType,
        s3: {
          actionType: 'putObject',
        },
      },
    }).then(async res => {
      const returnData = res.data.data;
      const { signedRequest } = returnData;

      // Put the fileType in the headers for the upload
      const options = {
        headers: {
          'Content-Type': myFileType,
        },
      };
      return await axios.put(signedRequest, file, options).then(async result => {
        let submitData = formData;
        submitData = {
          ...submitData,
          s3: { Key: returnData.Key },
          uniqueName: returnData.uniqueName,
          filePath: returnData.filePath,
        };
        return await axios({
          method: 'POST',
          url: `${APIS.SENTINEL_API}/api/v2/firmware/create`,
          headers: {
            Authorization: `Bearer ${session.getAccessToken().getJwtToken()}`,
          },
          data: submitData,
        });
      });
    }),
  );
};
